@if (event) {
  <div class="premium-after-attend-dialog-wrapper" #dialogWrapper>
    @if (!isEdit) {
      <div class="header">
        <div class="header-content">
          <img [src]="event.logoUrl" alt="Event logo" class="event-logo" />
          <div class="close-button-custom">
            <i class="far fa-times icon-regular" (click)="onClose()"></i>
          </div>
        </div>
      </div>
    }
    <div class="body">
      <div class="body-content">
        <div class="info">
          <div
            class="message content-padding"
            [innerHTML]="getTitle() | safeHtml"
          ></div>
          <div
            class="description content-padding"
            [innerHTML]="getDescription() | safeHtml"
          ></div>
        </div>
        <div class="info-actions-wrapper">
          <div class="info-actions content-padding">
            <div class="actions">
              <button
                class="btn btn-primary pop-color"
                (click)="hasConfirmed() ? seeRsvpQRCode() : onClose()"
              >
                {{ getCtaText() }}
              </button>

              <app-share-buttons
                [event]="event"
                [confirmationPageCard]="
                  findCardByType(EventConfirmationPageCardType.SHARE_OPTIONS)
                "
                customToastSuccessClass="toast-success-white-event-primary"
              ></app-share-buttons>
            </div>
            @if (hasConfirmed()) {
              <div class="add-to-wallet-actions">
                <div class="google-wallet" (click)="addToWallet()">
                  <img src="assets/add_to_google_wallet.svg" />
                </div>
                <div class="apple-wallet" (click)="addToWallet()">
                  <img src="assets/add-to-apple-wallet.svg" />
                </div>
              </div>
            }
          </div>
        </div>
        <div
          class="cards-content content-padding"
          [innerHtml]="getPremiumCustomDescription() | safeHtml"
        ></div>
      </div>
    </div>
    @if (!event.hideOriginalFooter && !isEdit) {
      <app-footer
        class="after-footer"
        [event]="event"
        [isEventFooter]="true"
        [showLogo]="false"
        [backgroundColor]="'transparent'"
        [bodyColor]="font?.bodyFontColor"
      ></app-footer>
    }
  </div>
}

@if (visual) {
  <div
    class="background-overlay"
    #backgroundOverlay
    [style.backgroundColor]="
      visual.backgroundColor ? visual.backgroundColor : ''
    "
    [style.background-image]="
      visualBackgroundUrl && visual.isBackgroundImage()
        ? 'url(' + visualBackgroundUrl + ')'
        : ''
    "
  >
    @if (visualBackgroundUrl && visual.isBackgroundVideo()) {
      <div class="background-video-cont">
        <video
          #backgroundVideo
          class="background-video"
          [muted]="'muted'"
          playsinline
          loop
          preload="metadata"
        >
          @if (visualBackgroundHevcUrl !== "") {
            <source
              [src]="visualBackgroundHevcUrl + '#t=0.001'"
              type="video/mp4;codecs=hvc1"
            />
          }
          <source
            [src]="visualBackgroundUrl"
            [type]="visual.background?.mimeType || 'video/mp4'"
          />
        </video>
      </div>
    }
  </div>

  @if (visualEffectUrl) {
    <div
      class="effect-overlay"
      #effectOverlay
      [style.background-image]="
        visualEffectUrl && visual.isEffectImage()
          ? 'url(' + visualEffectUrl + ')'
          : ''
      "
      [class.one-time-effect]="!visual.effect?.repeat"
    >
      @if (!visual.isEffectImage()) {
        <video
          #effectVideo
          class="effect-video"
          [muted]="'muted'"
          playsinline
          [loop]="visual.effect?.repeat"
          preload="metadata"
        >
          @if (visualEffectHevcUrl !== "") {
            <source
              [src]="visualEffectHevcUrl + '#t=0.001'"
              type="video/mp4;codecs=hvc1"
            />
          }
          <source
            [src]="visualEffectUrl"
            [type]="visual.effect?.mimeType || 'video/mp4'"
          />
        </video>
      }
    </div>
  }
}
